import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page - 1}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/core/feriados${queryUrl}`)
  },
  insertNew(data) {
    return axios.post('/core/feriados', data)
  },
  edit(data) {
    return axios.put(`/core/feriados/${data.id}`, data)
  },
  delete(id) {
    return axios.delete(`/core/feriados/${id}`)
  },
}
